import React from 'react';

const Network = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Network</h1>
      <p>Explore our extensive network in the hospitality industry.</p>
    </div>
  );
};

export default Network;
